// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-image-container {
  height: 100%;
}
.upload-image-container .upload-image-header {
  font-size: 1.75rem;
  font-weight: bold;
  text-align: center;
  text-transform: capitalize;
  color: var(--ion-color-primary-black);
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.upload-image-container .rating-container {
  padding: 1.25rem 0 1.875rem;
}
.upload-image-container .modal-close {
  position: absolute;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  width: 100%;
  top: 0.3125rem;
  left: 0;
}
.upload-image-container .modal-close .close-icon {
  cursor: pointer;
  max-width: 40px;
}
.upload-image-container .upload-body {
  overflow: auto;
  border: 1px solid #D5DADC;
  padding: 0.75rem 1.875rem 1.875rem;
  margin-top: 1.4375rem;
  height: 100%;
  max-height: 280px;
}
.upload-image-container .upload-body .note-text {
  margin: 0 0 0.75rem;
  font-size: 0.75rem;
  color: var(--ion-black-primary);
  opacity: 0.8;
}
.upload-image-container .upload-body .image-container {
  padding: 0 0.4375rem;
  display: flex;
  flex-wrap: wrap;
  column-gap: 0.75rem;
  row-gap: 0.75rem;
}
.upload-image-container .upload-body .image-container .upload-wrap {
  border: 1px solid #D5DADC;
  padding: 0 0.125rem;
  min-height: 100px;
  max-height: 100px;
}
.upload-image-container .upload-body .image-container .upload-wrap div {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.upload-image-container .upload-body .image-container .upload-wrap div ion-button {
  width: 90px;
  height: 38px;
}
.upload-image-container .upload-body .image-container .upload-wrap div ion-button::part(native) {
  box-shadow: none;
  border-radius: 0;
}
.upload-image-container .upload-body ion-col:first-child {
  padding-left: 0;
}
.upload-image-container .upload-body ion-col:last-child {
  padding-right: 0;
}

.uploadImage-bottom-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1.5625rem 1.875rem;
}
.uploadImage-bottom-container .cancel {
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;
  cursor: pointer;
}
.uploadImage-bottom-container .cancel:hover {
  font-weight: 600;
}
.uploadImage-bottom-container .product-button ion-button {
  --background: var(--ion-color-primary);
  width: 100px;
  height: 46px;
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  --box-shadow: none;
  --border-radius: 0;
}

.file-input {
  position: absolute;
  width: 1px;
  opacity: 0;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
}

.delete-icon {
  position: absolute;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 99999;
  border-radius: 100%;
  height: 1.875rem;
  width: 1.875rem;
  bottom: 0.625rem;
  right: 0.9375rem;
}

.preview-image-container {
  width: 100px;
  height: 100px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.more-info-tooltip img {
  cursor: pointer;
  position: absolute;
  left: 7%;
}

.more-info-file-tooltip {
  width: 20em !important;
}

.more-info-tooltip:hover .more-info-tooltiptext {
  visibility: visible;
}

.more-info-tooltip .more-info-tooltiptext {
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 0.4375rem 0.5rem;
  left: 15%;
  top: 15%;
  font-size: 0.75rem;
  position: absolute;
  z-index: 999999;
  word-break: break-word;
  max-width: 400px;
  max-height: 100px;
  overflow: auto;
}

.info-ltr img {
  right: unset !important;
  left: 7%;
}
.info-ltr .more-info-tooltiptext {
  left: 11% !important;
  top: 30% !important;
  right: unset !important;
}

.info-rtl .more-info-tooltiptext {
  right: 11% !important;
  left: unset !important;
  top: 30% !important;
}
.info-rtl img {
  left: unset !important;
  right: 7%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/upload-image/upload-image.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qCAAA;EACA,uBAAA;EACA,gBAAA;EACA,+BAAA;EACA,qBAAA;EACA,4BAAA;AACR;AAEI;EACI,2BAAA;AAAR;AAGI;EACI,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,OAAA;AADR;AAEQ;EACE,eAAA;EACA,eAAA;AAAV;AAKI;EACI,cAAA;EACA,yBAAA;EACA,kCAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;AAHR;AAIQ;EACI,mBAAA;EACA,kBAAA;EACA,+BAAA;EACA,YAAA;AAFZ;AAIQ;EACI,oBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAFZ;AAIY;EACI,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AAFhB;AAIgB;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFpB;AAIoB;EACI,WAAA;EACA,YAAA;AAFxB;AAKoB;EACI,gBAAA;EACA,gBAAA;AAHxB;AASQ;EACI,eAAA;AAPZ;AAUQ;EACI,gBAAA;AARZ;;AAaA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,2BAAA;AAVJ;AAYI;EACI,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,gDAAA;EACA,eAAA;AAVR;AAYQ;EACI,gBAAA;AAVZ;AAeQ;EACI,sCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAbZ;;AAkBA;EACI,kBAAA;EACA,UAAA;EACA,UAAA;AAfJ;;AAkBA;EACI,eAAA;EACA,gBAAA;AAfJ;;AAkBA;EACI,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAfJ;;AAkBA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAfJ;;AAmBI;EACI,eAAA;EACA,kBAAA;EACA,QAAA;AAhBR;;AAoBA;EACI,sBAAA;AAjBJ;;AAoBA;EACI,mBAAA;AAjBJ;;AAoBA;EACI,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAjBJ;;AAqBI;EACI,uBAAA;EACA,QAAA;AAlBR;AAoBI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;AAlBR;;AAsBI;EACI,qBAAA;EACA,sBAAA;EACA,mBAAA;AAnBR;AAqBI;EACI,sBAAA;EACA,SAAA;AAnBR","sourcesContent":[".upload-image-container {\n    height: 100%;\n\n    .upload-image-header {\n        font-size: 1.75rem;\n        font-weight: bold;\n        text-align: center;\n        text-transform: capitalize;\n        color: var(--ion-color-primary-black);\n        text-overflow: ellipsis;\n        overflow: hidden;\n        display: -webkit-box !important;\n        -webkit-line-clamp: 1;\n        -webkit-box-orient: vertical;\n    }\n\n    .rating-container {\n        padding: 1.25rem 0 1.875rem;\n    }\n\n    .modal-close {\n        position: absolute;\n        display: flex;\n        justify-content: flex-end;\n        position: absolute;\n        width: 100%;\n        top: 0.3125rem;\n        left: 0;\n        .close-icon {\n          cursor: pointer;\n          max-width: 40px;\n        }\n        \n    }\n\n    .upload-body {\n        overflow: auto;\n        border: 1px solid #D5DADC;\n        padding: 0.75rem 1.875rem 1.875rem;\n        margin-top: 1.4375rem;\n        height: 100%;\n        max-height: 280px;\n        .note-text{\n            margin: 0 0 0.75rem;\n            font-size: 0.75rem;\n            color: var(--ion-black-primary);\n            opacity: 0.8;\n        }\n        .image-container {\n            padding: 0 0.4375rem;\n            display: flex;\n            flex-wrap: wrap;\n            column-gap: 0.75rem;\n            row-gap: 0.75rem;\n\n            .upload-wrap {\n                border: 1px solid #D5DADC;\n                padding: 0 0.125rem;\n                min-height: 100px;\n                max-height: 100px;\n\n                div {\n                    height: 100%;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n\n                    ion-button {\n                        width: 90px;\n                        height: 38px;\n                    }\n\n                    ion-button::part(native) {\n                        box-shadow: none;\n                        border-radius: 0;\n                    }\n                }\n            }\n        }\n\n        ion-col:first-child {\n            padding-left: 0;\n        }\n\n        ion-col:last-child {\n            padding-right: 0;\n        }\n    }\n}\n\n.uploadImage-bottom-container {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 1.5625rem 1.875rem;\n\n    .cancel {\n        font-weight: 400;\n        font-size: 0.9375rem;\n        line-height: 1.125rem;\n        letter-spacing: 0.4px;\n        text-transform: uppercase;\n        color: var(--ion-color-secondary-black);\n        padding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;\n        cursor: pointer;\n\n        &:hover {\n            font-weight: 600;\n        }\n    }\n\n    .product-button {\n        ion-button {\n            --background: var(--ion-color-primary);\n            width: 100px;\n            height: 46px;\n            font-weight: 600;\n            font-size: 0.9375rem;\n            line-height: 1.125rem;\n            letter-spacing: 0.4px;\n            --box-shadow: none;\n            --border-radius: 0;\n        }\n    }\n}\n\n.file-input {\n    position: absolute;\n    width: 1px;\n    opacity: 0;\n}\n\n.preview-image {\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.delete-icon {\n    position: absolute;\n    background: #FFFFFF;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    z-index: 99999;\n    border-radius: 100%;\n    height: 1.875rem;\n    width: 1.875rem;\n    bottom: 0.625rem;\n    right: 0.9375rem;\n}\n\n.preview-image-container {\n    width: 100px;\n    height: 100px;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.more-info-tooltip {\n    img {\n        cursor: pointer;\n        position: absolute;\n        left: 7%;\n     }\n}\n\n.more-info-file-tooltip {\n    width: 20em !important;\n}\n\n.more-info-tooltip:hover .more-info-tooltiptext {\n    visibility: visible;\n}\n\n.more-info-tooltip .more-info-tooltiptext {\n    visibility: hidden;\n    background-color: black;\n    color: #fff;\n    text-align: center;\n    border-radius: 6px;\n    padding: 0.4375rem 0.5rem;\n    left: 15%;\n    top: 15%;\n    font-size: 0.75rem;\n    position: absolute;\n    z-index: 999999;\n    word-break: break-word;\n    max-width: 400px;\n    max-height: 100px;\n    overflow: auto;\n}\n\n.info-ltr{\n    img{\n        right: unset !important;\n        left: 7%;\n    }\n    .more-info-tooltiptext{\n        left: 11% !important;\n        top: 30% !important;\n        right: unset !important;\n    }\n}\n.info-rtl{\n    .more-info-tooltiptext{\n        right: 11% !important;\n        left: unset !important;\n        top: 30% !important;\n    }\n    img{\n        left: unset !important;\n        right: 7%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
